import React, { useEffect, useRef, useState } from "react";
import api from "../../util/panelApi";

/// 5 Kas: canli yayini gizli izleme. Agora'ya IZLEYICI olarak girer (yayin yapmaz, kamera/mikrofon acmaz).
/// Uygulamadaki izleyici listesi/sayisi soketten geldigi icin admin orada gorunmez.
const SDK = "https://cdn.jsdelivr.net/npm/agora-rtc-sdk-ng@4.20.2/AgoraRTC_N-production.js";
const sdkYukle = () =>
  window.AgoraRTC
    ? Promise.resolve(window.AgoraRTC)
    : new Promise((ok, no) => {
        const s = document.createElement("script");
        s.src = SDK;
        s.onload = () => ok(window.AgoraRTC);
        s.onerror = () => no(new Error("Agora yüklenemedi"));
        document.head.appendChild(s);
      });

const GizliIzle = ({ stream, onClose, oda = false }) => {
  const kutu = useRef(null);
  const [durum, setDurum] = useState("Bağlanıyor…");
  const [ses, setSes] = useState(true);
  const istemci = useRef(null);
  const sesler = useRef([]);

  useEffect(() => {
    let bitti = false;
    (async () => {
      try {
        const b = oda ? await api.incDinle(stream._id) : await api.incIzle(stream._id);
        if (!b?.status) return setDurum(b?.message || "Bilet alınamadı");
        const AgoraRTC = await sdkYukle();
        AgoraRTC.setLogLevel(3);
        const c = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
        istemci.current = c;
        await c.setClientRole("audience", { level: 1 });
        c.on("user-published", async (user, media) => {
          await c.subscribe(user, media);
          if (media === "video" && kutu.current) {
            const d = document.createElement("div");
            d.id = `u${user.uid}`;
            d.style.cssText = "flex:1 1 280px;min-height:360px;background:#000;border-radius:10px;overflow:hidden";
            kutu.current.appendChild(d);
            user.videoTrack.play(d);
          }
          if (media === "audio") {
            sesler.current.push(user.audioTrack);
            user.audioTrack.play();
          }
          setDurum(oda ? "Dinleniyor" : "İzleniyor");
        });
        c.on("user-unpublished", (user, media) => {
          if (media === "video") document.getElementById(`u${user.uid}`)?.remove();
        });
        c.on("user-left", (user) => document.getElementById(`u${user.uid}`)?.remove());
        await c.join(b.appId, b.channel, b.token, b.uid);
        if (bitti) return c.leave();
        setDurum((d) => (d === "Bağlanıyor…" ? "Bağlandı, görüntü bekleniyor…" : d));
      } catch (e) {
        setDurum("Hata: " + (e?.message || e));
      }
    })();
    return () => {
      bitti = true;
      try {
        istemci.current?.leave();
      } catch (_) {}
    };
  }, [stream._id]);

  const sesDegis = () => {
    const y = !ses;
    sesler.current.forEach((t) => {
      try {
        t.setVolume(y ? 100 : 0);
      } catch (_) {}
    });
    setSes(y);
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.6)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={onClose}>
      <div className="card" style={{ width: "min(900px,100%)", maxHeight: "92vh", overflow: "auto", margin: 0 }} onClick={(e) => e.stopPropagation()}>
        <div className="card-body">
          <div className="d-flex align-items-center" style={{ gap: 10, marginBottom: 10 }}>
            <b>{oda ? "🎧 Gizli dinleme" : "🕶️ Gizli izleme"} · {stream.name || stream.roomName || ""}</b>
            <span className="badu-chip info">{durum}</span>
            <button className="btn btn-light btn-sm" style={{ marginLeft: "auto" }} onClick={sesDegis}>{ses ? "🔊 Sesi kapat" : "🔇 Sesi aç"}</button>
            <button className="btn btn-danger btn-sm" onClick={onClose}>Kapat</button>
          </div>
          <div ref={kutu} style={{ display: "flex", flexWrap: "wrap", gap: 8, minHeight: 360, background: "#111", borderRadius: 10, padding: 8 }} />
          <div style={{ fontSize: 12, color: "#6B7280", marginTop: 8 }}>Yayıncı ve izleyiciler seni görmez; izleyici listesine ve sayısına girmezsin. Kamera ve mikrofonun açılmaz.</div>
        </div>
      </div>
    </div>
  );
};

export default GizliIzle;
